@if (resourceCreationBlocked()) {
  <mat-accordion>
    <mat-expansion-panel [expanded]="true" [disabled]="true">
      <mat-expansion-panel-header class="bricks-chevron">
        <mat-panel-title>
          <bricks-icon class="left-side chevron-default">bricks-chevron-down</bricks-icon>
          <span class="accordion-title">
            Stromerzeugungseinheit (Technische Ressource
            {{ this.getTechnicalResourceTitle(0) }})
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <span class="if-empty-text">
        Bitte vervollständigen Sie die Angaben zu Ihrer Anlage, Vermarktungsform und Vertragslaufzeit.
      </span>
    </mat-expansion-panel>
  </mat-accordion>
}
@for (resource of formArray.controls; track $index) {
  <mat-accordion [attr.id]="'technical-resource-' + $index">
    <mat-expansion-panel [hideToggle]="true" [expanded]="isExpanded($index)" #panel>
      <mat-expansion-panel-header class="bricks-chevron padding-test">
        <mat-panel-title>
          <bricks-icon [class.chevron-rotated]="panel.expanded" class="left-side">bricks-chevron-down</bricks-icon>
          <span class="accordion-title">
            Stromerzeugungseinheit (Technische Ressource
            {{ getTechnicalResourceTitle($index) }})
          </span>
          <bricks-label style="margin-left: 15px; flex: 1 1 auto" [type]="getStatusLabelStyle(resource)">
            {{ getResourceStatus(resource) }}
          </bricks-label>
          @if (deleteResourceButtonVisible()) {
            <button
              type="button"
              name="deleteResourceIcon"
              class="bricks-button button-fn delete-button-small"
              (click)="deleteResource($event, $index)">
              <bricks-icon>bricks-trash</bricks-icon>
            </button>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <h3>
        <span>Marktstammdatenregister-Nummer</span>
      </h3>
      <span class="desc-text">
        Sollte die Stromerzeugungseinheit bereits im Marktstammdatenregister registriert sein, können Sie die dort
        hinterlegten Daten mithilfe der SEE-Nummer in die nachfolgenden Felder übertragen. Falls nicht, befüllen Sie die
        Felder manuell.
      </span>
      <div class="flex-row">
        <div class="flex-col-49 input-tooltip-row">
          @let mastrIdGenerationUnit = getControl(resource, 'mastrIdGenerationUnit');
          <bricks-input
            [showResetOption]="true"
            appDigitsOnly
            [allowPrefix]="true"
            [allowComma]="false"
            [label]="'Marktstammdatenregister-Nummer der Einheit'"
            [placeholder]="'z. B. SEE123456789012'"
            [width]="'fill'"
            [type]="'text'"
            [formControl]="mastrIdGenerationUnit"
            name="mastrIdGenerationUnit">
            @if (mastrIdGenerationUnit.touched && mastrIdGenerationUnit.hasError('pattern')) {
              <bricks-error>Eingabe muss mit SEE beginnen, gefolgt von 12 Ziffern</bricks-error>
            }
          </bricks-input>
          <app-tooltip
            text="Die Marktstammdatenregisternummer (MaStR-Nr.) wird bei der Registrierung im Marktstammdatenregister vergeben, ist 15-stellig und beginnt immer mit SEE. Die Nummer können Sie bei Ihrem Verteilnetzbetreiber anfragen. Die Anmeldung Ihrer Anlage im Marktstammdatenregister kann auch vor der Inbetriebnahme erfolgen. Wichtig bei der Übermittlung: Wir benötigen die MaStR-Nr. der Einheit, nicht die Nummer der EEG-Anlage!"></app-tooltip>
        </div>
        <div class="flex-col fetch-button">
          <button
            name="applyMarketRegisterDataButton"
            class="bricks-button button-fn button-icon-left"
            [disabled]="isApplyMarketRegisterDataButtonDisabled(resource)"
            (click)="applyMarketRegisterData(resource, $index); this.trackEventApplyMarketRegisterData()">
            <bricks-icon>bricks-load-1</bricks-icon>
            <span>Daten abrufen</span>
          </button>
        </div>
      </div>

      <h3>
        <span>Identifikation</span>
      </h3>
      <div class="flex-row">
        <div class="flex-col-49">
          <div class="input-tooltip-row">
            @let installedCapacityKW = getControl(resource, 'installedCapacityKW');
            <bricks-input
              [showResetOption]="true"
              appDigitsOnly
              appFormatView
              [focusInFormatter]="$any(ViewFormatterService.numberToStringFormatter)"
              [focusOutFormatter]="ViewFormatterService.numberToLocaleStringFormatter()"
              [changeFormatter]="ViewFormatterService.stringToNumberFormatter"
              [label]="'Installierte Leistung'"
              [placeholder]="'z. B. 700'"
              [isRequired]="true"
              [formControl]="installedCapacityKW"
              [width]="'fill'"
              name="installedCapacityKW">
              <span text-suffix>kW(p)</span>
              @if (installedCapacityKW.errors && installedCapacityKW.touched) {
                <bricks-error>
                  {{ getInstalledCapacityError(installedCapacityKW) }}
                </bricks-error>
              }
            </bricks-input>
            <app-tooltip
              text="Bitte geben Sie die Bruttoleistung in kW(p) aus dem Marktstammdatenregister ein. Die Leistung der gesamten Stromerzeugungseinheit können Sie z.B. dem Inbetriebnahmeprotokoll entnehmen."></app-tooltip>
          </div>
        </div>
        <div class="flex-col-49 input-tooltip-row">
          <bricks-date-picker
            [showResetOption]="true"
            [label]="isAlreadyInOperation() ? 'Datum der erstmaligen Inbetriebnahme' : 'Geplantes Inbetriebnahmedatum'"
            [placeholder]="'TT.MM.JJJJ'"
            [isRequired]="true"
            [formControl]="getControl(resource, 'commissioningDateCommon')"
            [width]="'fill'"
            [selectionFilter]="commissioningDateFilter()"
            [manualEntry]="false">
            @if (getControl(resource, 'commissioningDateCommon').errors) {
              <bricks-error>
                {{ getCommissioningDateError(resource) }}
              </bricks-error>
            }
          </bricks-date-picker>
          <app-tooltip
            [text]="
              isAlreadyInOperation() ? commissioningDateInPastTooltip : commissioningDateInFutureTooltip
            "></app-tooltip>
        </div>
      </div>
      <div class="flex-col-49 input-tooltip-row">
        @let applicableValueCentsPerkWh = getControl(resource, 'applicableValueCentsPerkWh');
        <bricks-input
          [showResetOption]="true"
          appDigitsOnly
          [allowComma]="true"
          appFormatView
          [focusInFormatter]="$any(ViewFormatterService.numberToStringFormatter)"
          [focusOutFormatter]="ViewFormatterService.currencyToLocaleStringFormatter()"
          [changeFormatter]="ViewFormatterService.stringToNumberFormatter"
          [label]="'Anzulegender Wert'"
          [placeholder]="'z. B. 8,34'"
          [isRequired]="isAlreadyInOperation() ?? false"
          [formControl]="applicableValueCentsPerkWh"
          [width]="'fill'"
          name="applicableValueCentsPerkWh">
          <span text-suffix>ct/kWh</span>
          @if (applicableValueCentsPerkWh.errors && applicableValueCentsPerkWh.touched) {
            <bricks-error>
              {{ getApplicableValueCentsPerkWhError(applicableValueCentsPerkWh) }}
            </bricks-error>
          }
        </bricks-input>
        <app-tooltip [text]="applicableValueTooltip"></app-tooltip>
      </div>
      <div class="external-link-section">
        <a href="{{ federalNetworkAgencyLink }}" target="_blank" rel="noopener noreferrer">
          <u>zur Bundesnetzagentur</u>
          <bricks-icon class="bricks-icon">bricks-open-in-new</bricks-icon>
        </a>
        @if (isEegCalcLinkVisible($index)) {
          <a href="{{ eegCalcLink }}" target="_blank" rel="noopener noreferrer">
            <u>zum EEG-Rechner</u>
            <bricks-icon class="bricks-icon">bricks-open-in-new</bricks-icon>
          </a>
        }
      </div>

      <span class="geo-hint">Standort im WGS84-Format</span>
      <bricks-alert
        class="bricks-alert-full-width-no-content"
        title="Geokoordinaten eingeben oder Standort in der Karte anklicken und anschließend festlegen."
        type="info-outline"
        [isClosable]="false"></bricks-alert>
      <div class="flex-row geo-input-row">
        <div class="flex-col-50">
          <app-input-geo
            type="latitude"
            placeholder="z. B. 49.00623908202564"
            width="fill"
            [range]="latitudeRange"
            [isLocationValid]="getLocationValiditySignal($index)"
            [isRequired]="true"
            [ctrl]="getControl(resource, 'latitude')"></app-input-geo>
        </div>

        <div class="flex-col-50">
          <app-input-geo
            type="longitude"
            placeholder="z. B. 8.437091353427137"
            width="fill"
            [range]="longitudeRange"
            [isLocationValid]="getLocationValiditySignal($index)"
            [isRequired]="true"
            [ctrl]="getControl(resource, 'longitude')"></app-input-geo>
        </div>
      </div>
      <app-map
        [resource]="getGenericResourceControl(resource)"
        [resourceId]="$index"
        [isLocationValid]="getLocationValiditySignal($index)"
        [technology]="productionTechnology"></app-map>
      <h3>
        <span>Technologiespezifische Daten</span>
      </h3>
      @if (productionTechnology() === ProductionTechnology.Solar) {
        <app-solar-specific-technical-data [resource]="getSolarResourceControl(resource)" [resourceId]="$index" />
      } @else if (productionTechnology() === ProductionTechnology.WindOnshore) {
        <app-wind-specific-technical-data [resource]="getWindResourceControl(resource)" />
      }
      <div class="flex-row align-right">
        @if (deleteResourceButtonVisible()) {
          <button
            type="button"
            name="deleteResourceButton"
            class="bricks-button button-icon-left button-fn delete-button"
            (click)="deleteResource($event, $index)">
            <bricks-icon>bricks-trash</bricks-icon>
            <span>Löschen</span>
          </button>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}

@if (addResourceButtonVisible()) {
  <div class="flex-row add-entry">
    <button
      type="button"
      name="addResourceButton"
      class="bricks-button button-fn-ghost"
      (click)="trackEventAddResource(); addResource()">
      <span> Weitere Stromerzeugungseinheit hinzufügen ({{ resourceCounter() }}/{{ MAX_RESOURCES_COUNT }}) </span>
      <bricks-icon>bricks-circle-plus</bricks-icon>
    </button>
  </div>
}
